var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPainPointLowerBackPainGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 67.251,
    height: 87.858,
    viewBox: "0 0 67.251 87.858",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4406",
    "data-name": "Rectangle 4406",
    width: 37.691,
    height: 21.818,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4407",
    "data-name": "Rectangle 4407",
    width: 34.644,
    height: 16.109,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4408",
    "data-name": "Rectangle 4408",
    width: 30.231,
    height: 10.778,
    fill: "rgba(169,32,32,0.9)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4499",
    "data-name": "Group 4499",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2876",
    "data-name": "Group 2876",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7015",
    "data-name": "Path 7015",
    d: "M173.2,396.288s4.331,15.875,7.9,27.915q1.617.119,3.266.12a44.387,44.387,0,0,0,5.182-.3l.837-20.417s-19.454-20.155-17.181-7.316",
    transform: "translate(-148.504 -336.465)",
    fill: "#221e3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7016",
    "data-name": "Path 7016",
    d: "M179.354,283.6l-5.461,11.333a29.763,29.763,0,0,0-.562,8.078,21.511,21.511,0,0,0,1.954,4.3c3.417,4.455,5.322,4.828,7.855,11.967,2.12,5.973,2.426,8.732,2.261,11.992a43.718,43.718,0,0,0,24.986-8.372c.79-3.881,1.469-8.143,2.01-13.062,1.37-12.467-1.921-18.59-1.921-18.59Z",
    transform: "translate(-148.711 -243.412)",
    fill: "#221e3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7017",
    "data-name": "Path 7017",
    d: "M154.278,31l.348-5-1.948-6.138-1.6-10.124a43.78,43.78,0,0,0-16.9-8.427c-2.824.351-6.765.526-9.61-.608a13.075,13.075,0,0,1-1.494-.7,43.741,43.741,0,0,0-18.464,4.258l-2.5,2.358,6.984,11.083,1.292-1.52,1.427,1.573,2.934,8.466,3.758,6.882.661,4.727L112.6,48.581s-.221,3.223,11.649,8.542c17.142,6.905,28.256-.865,28.256-.865l-2.872-12.366a28.754,28.754,0,0,1-.524-5.583L149.254,36Z",
    transform: "translate(-87.64 -0.013)",
    fill: "#b1d34a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7018",
    "data-name": "Path 7018",
    d: "M165.115,1.686c-2.641,15.375,7.328,22.908,14.1,25.115,10.6,3.454,19.307-10.244,20.151-14.865.308-1.683-.226-4-.969-6.5a44.074,44.074,0,0,0-33.284-3.754",
    transform: "translate(-141.346 0)",
    fill: "#221e3f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2868",
    "data-name": "Group 2868",
    transform: "translate(26.45 41.882)",
    opacity: 0.22
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2867",
    "data-name": "Group 2867"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2866",
    "data-name": "Group 2866",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7019",
    "data-name": "Path 7019",
    d: "M189.963,296.4s5.872-1.585,10.98-.345c5.061,1.228,11.6,4.791,11.6,4.791a37.434,37.434,0,0,0,8.183,2.69c4.108.781,5.928,8.691-1.085,11.443-4.894,1.92-23.833,6.742-31.693-6.814-3.779-6.518,2.013-11.764,2.013-11.764",
    transform: "translate(-186.671 -295.581)",
    fill: "#ff5543",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2871",
    "data-name": "Group 2871",
    transform: "translate(27.442 42.701)",
    opacity: 0.32
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2870",
    "data-name": "Group 2870"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2869",
    "data-name": "Group 2869",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7020",
    "data-name": "Path 7020",
    d: "M195.973,301.359s6.338,1.512,9.984,1.228c2.615-.2,12.186,5.341,12.186,5.341s8.368.549,9.809,3.723c1.561,3.437-2.217,2.487-5.273,3.834-4.349,1.917-18.4,4.99-27.1-5.126-4.505-5.234.4-9,.4-9",
    transform: "translate(-193.672 -301.359)",
    fill: "#ff5543",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2874",
    "data-name": "Group 2874",
    transform: "translate(29.347 45.324)",
    opacity: 0.84
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2873",
    "data-name": "Group 2873"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2872",
    "data-name": "Group 2872",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7021",
    "data-name": "Path 7021",
    d: "M209.25,319.881s6.49.057,8.3.3c2.5.333,8.894,3.547,8.894,3.547s3.222,1.833,5.477,1.932c8.594.377,5.648,3.074.318,4.438-5.1,1.3-19.4.732-24.1-6.3-2.841-4.256,1.108-3.914,1.108-3.914",
    transform: "translate(-207.114 -319.874)",
    fill: "rgba(169,32,32,0.9)",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_7022",
    "data-name": "Path 7022",
    d: "M312.428,271.452l-5.717-3.691c2.378.729,8.127-4.74,10.982-4.736l.732,4.5v4.013l-.415,5.324-.769,2.285h-1.329l-.042-2.285-6.227,1.181-3.409.769-1.011-2.07,3.748-4.467Z",
    transform: "translate(-261.976 -225.757)",
    fill: "#f49864"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7023",
    "data-name": "Path 7023",
    d: "M315.715,165.3l1.078-6.881,6.646-14.77,9.262,4.773-7.3,14.766.086.25-4.9,3.9Z",
    transform: "translate(-270.98 -123.296)",
    fill: "#ffb080"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7024",
    "data-name": "Path 7024",
    d: "M13.32,72.484l7.71-8.049-5.8-9.206L3.424,67.758,0,74.495l2.806,3.4s21.657,8.469,23.511,9.7l1.475,5.024,5.46,3.36,2.612-1.739-2.338-6.52s-5.171-5.142-6.692-5.741C23.361,80.312,13.526,71.8,13.32,72.484",
    transform: "translate(0 -47.404)",
    fill: "#ef9373"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7025",
    "data-name": "Path 7025",
    d: "M352.224,35.5l6.039,3.334,3.84,3.1-1.2,5.912-5.928,13-11.451-5.535,4.67-14.38Z",
    transform: "translate(-294.852 -30.467)",
    fill: "#9bba3e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4409",
    "data-name": "Rectangle 4409",
    width: 67.251,
    height: 87.858,
    fill: "none"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4410",
    "data-name": "Rectangle 4410",
    width: 67.251,
    height: 87.858,
    transform: "translate(0 0)",
    fill: "none"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPainPointLowerBackPainGreen);
export default __webpack_public_path__ + "static/media/painPointLowerBackPainGreen.b8c2aace8840fb059714708c4ea17a7e.svg";
export { ForwardRef as ReactComponent };